export const ENTERPRISE_ACCOUNT_MANAGER_MODAL = 'EnterpriseAccountMangerModal';
export const DELAYED_PAYMENT_MODAL_NAME = 'DelayedPaymentModal';
export const CONFIRM_ACTION_MODAL = 'ConfirmActionModal';
export const CREATE_NEW_FOLDER_MODAL = 'CreateNewFolderModal';
export const PAYMENT_MODAL_NAME = 'PaymentPopUp';
export const SHARE_FOLDER_MODAL = 'ShareFolderModal';
